import { useDispatch } from 'react-redux';
import { addNotificationAction } from 'store/notifications/notificationsActions';

export const useSnackbar = () => {
  const dispatch = useDispatch();

  const notify = (variant: 'error' | 'info' | 'success' | 'warning') => (message: string) =>
    dispatch(
      addNotificationAction({
        message,
        variant,
      }),
    );

  return {
    error: notify('error'),
    info: notify('info'),
    success: notify('success'),
    warning: notify('warning'),
  };
};
